<template>
  <div>
    <el-container>
      <el-header style="z-index: 999;">
        <div ref="header" class="nav">
          <div class="nav-top-container">
            <div class="nav-logo" style="padding-right: 20px">
              <router-link to="/"
                ><img src="@/assets/boyuan_60.png"
              /></router-link>
            </div>

            <div class="nav-item-box" style="display: flex">
              <div
                class="nav-item"
                :class="{ active: $route.path.includes('/training') }"
                style="min-width: 64px"
              >
                <router-link to="/training">实训</router-link>
              </div>
              <div
                class="nav-item"
                :class="{ active: $route.path.includes('/course') }"
                style="min-width: 64px"
              >
                <router-link to="/course">课程</router-link>
              </div>
              <div
                class="nav-item"
                :class="{ active: $route.path.includes('/exam') }"
                style="min-width: 64px"
              >
                <router-link to="/exam">考试</router-link>
              </div>
              <!-- <div class="nav-item" style="min-width: 96px">
                <a>慕课教程</a>
              </div> -->
            </div>
            <div class="nav-right-container">
              <!-- <div class="nav-right-search" style="padding-right: 10px;">
                <el-input
                  placeholder="请输入课程关键字"
                  class="nav-right-search-input"
                  size="small"
                >
                  <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
              </div> -->
              <!-- <div class="nav-right-user" style="min-width: 96px">
                <a>个人中心</a>
              </div> -->
              <!-- <div
                v-show="
                  roles.includes('System') |
                    roles.includes('Administrator') |
                    roles.includes('Admin') |
                    roles.includes('Teacher')
                "
                class="nav-right-link"
              >
                <el-link :href="webSite" target="_blank">前往管理平台</el-link>
              </div> -->
              <div
                v-show="hasAccess"
                class="nav-right-message"
                style="text-align: center"
              >
                <message />
              </div>
              <div class="nav-right-login" style="min-width: 60px">
                <el-dropdown
                  v-show="hasAccess"
                  :hide-on-click="false"
                  placement="bottom"
                >
                  <span class="el-dropdown-link">
                    <el-avatar
                      icon="el-icon-user-solid"
                      :src="avatar"
                    ></el-avatar>
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="toProfile"
                      >个人中心</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="toMyCourse"
                      >我的课程</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="toOrder"
                      >我的订单</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="toLearningCard"
                      >我的学习卡</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="toCoupon"
                      >我的优惠券</el-dropdown-item
                    >
                    <el-dropdown-item @click.native="toMyLink"
                      >我的链接</el-dropdown-item
                    >
                    <el-dropdown-item
                      style="text-align: center"
                      @click.native="signOutOidc"
                      divided
                      >退出</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button
                  v-show="!hasAccess"
                  @click.prevent="authenticateOidcPopup"
                  type="primary"
                  size="medium"
                  round
                  >登录/注册</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div class="footer-copyright-container">
          <div class="footer-copyright" style="text-align: center">
            <span style="color: #999">Copyright © 2025 广州铂元信息科技有限公司 </span>
            <a class="footer-link" href="https://beian.miit.gov.cn" target="_blank" rel="nofollow">粤ICP备2020078167号-2</a>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import Message from "./components/Message";
import { mapGetters, mapActions } from "vuex";
import config from "@/utils/config";

export default {
  name: "Layout",
  components: {
    Message,
  },
  computed: {
    ...mapGetters("user", ["name", "avatar", "roles"]),
    ...mapGetters("oidc", [
      "oidcIsAuthenticated",
      "oidcUser"
    ]),
    hasAccess: function () {
      return this.oidcIsAuthenticated;
    },
  },
  data() {
    return {
      webSite: "",
    };
  },
  created() {
    //console.log(document.body.scrollTop);
    this.fetchConfig();
  },
  mounted() {
    // window.addEventListener("resize", () => {
    //   console.log("wh:", window.innerHeight);
    // });
    window.addEventListener(
      "scroll",
      () => {
        this.$nextTick(() => {
          const heightTop = document.documentElement.scrollTop;
          if (heightTop > 0) {
            this.$refs.header.classList.value = "nav fixed";
          } else {
            this.$refs.header.classList.value = "nav";
          }
        });
      },
      true
    );
  },
  methods: {
    ...mapActions("oidc", ["signOutOidc", "authenticateOidc", "authenticateOidcPopup"]),
    toProfile() {
      this.$router.push("/profile");
    },
    toMyCourse() {
      this.$router.push("/profile?tab=course");
    },
    toRecord() {
      this.$router.push("/profile?tab=record");
    },
    toOrder() {
      this.$router.push("/profile?tab=order");
    },
    toLearningCard() {
      this.$router.push("/profile?tab=learning");
    },
    toCoupon() {
      this.$router.push("/profile?tab=coupon");
    },
    toMyLink() {
      this.$router.push("/profile?tab=link");
    },
    async fetchConfig() {
      await config.getTeacherWebSite.then((res) => {
        this.webSite = res;
      });
    },
  },
};
</script>

<style>
.el-header {
  padding: 0 !important;
}
.el-main {
  padding: 0 !important;
  overflow: visible;
}

a {
  text-decoration: none;
  color: #000;
}
.router-link-active {
  text-decoration: none;
  color: #000;
}

.active {
  background-color: #efefef;
}

.el-popover {
  top: 50px !important;
  padding: 0 !important;
}

.el-dropdown-menu {
  top: 50px !important;
  width: 160px;
}
</style>
<style scoped>
.nav {
  background: #ffffff;
  border-bottom: 1px solid #f3f5f6;
  display: flex;
}

.fixed {
  width: 100%;
  position: fixed;
  z-index: 999;
  box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
}

.nav-top-container {
  margin: 0px auto;
  display: flex;
  width: 1200px;
  height: 62px;
}

.nav-logo {
  display: flex;

  margin: auto 0;
}

.nav-logo img {
  height: 52px;
}
.nav-logo span {
  line-height: 62px;
}

.nav-item-box {
  flex-grow: 1;
}

.nav-item {
  cursor: pointer;
  float: left;

  margin: 0;
}

.nav-item a {
  display: block;
  font-size: 16px;
  font-family: 微软雅黑, "Microsoft YaHei";
  height: 62px;
  line-height: 62px;
  padding: 0 16px;
}
.nav-item a:hover {
  color: #1890ff;
}

.nav-right-container {
  margin: auto 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.nav-right-search {
  margin: auto 0 !important;
  min-width: 150px;
}

.nav-right-search-input {
  border-radius: 10px;
}

.nav-right-user {
  margin: auto 0;
  cursor: pointer;
}

.nav-right-user a {
  display: block;
  font-size: 16px;
  font-family: 微软雅黑, "Microsoft YaHei";
  padding: 0 16px;
}

.nav-right-user a:hover {
  color: #1890ff;
}

.nav-right-login {
  cursor: pointer;
}

.nav-right-message {
  margin: auto 0;
  cursor: pointer;
  min-width: 50px;
}

.nav-right-message i {
  font-size: 22px;
}

.nav-right-link {
  margin: auto 0;
  cursor: pointer;
  min-width: 50px;
}

.footer-copyright {
  color: rgb(153, 153, 153);
}

.footer-copyright a, .footer-copyright span {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  margin-right: 10px;
}

.footer-link {
  color: rgb(153, 153, 153);
}
</style>
